import { IApplicationState } from '../../types/redux';
import { getReviewById } from './getReviewById';

export const getReviewAuthorNameById = (id: string) => (state: IApplicationState) => {
  const review = getReviewById(id)(state);

  return review?.user?.name || '';
};
